// 正则公共
// @desc 正则公共文件
// @author ss
// @date 随时更新
// @example this.$reg.正则名
export default {
    name: /^[a-zA-Z\u4e00-\u9fa5·]+$/i,
    pw: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]+$/,
    inviteCode: /^[0-9a-zA-Z]*$/,
    num: /^\d+$/,
    money: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/,
    phone: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/,
    email: /^[A-Za-z0-9\u4e00-\u9fa5_]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
}



// WEBPACK FOOTER //
// ./src/assets/js/reg.js